import { capitalize } from "lodash";

import { LabOrder } from "pwapi";

const FLAG_REASON_DISPLAY_OVERRIDES: Partial<Record<string, string>> = {
  "fortyx-rescan": "40X Rescan", //  "40x-rescan" is a unique case here (since it begins with an number).
};

export function splitFlagReason(reason: string): string {
  return (
    FLAG_REASON_DISPLAY_OVERRIDES[reason] ??
    reason
      .split("-")
      .map((s) => capitalize(s))
      .join(" ")
  );
}

const noChargeReasonLabels = {
  "stain-not-optimal": "Stain not technically optimal",
  academic: "Stain performed for academic purposes",
  noncontributory: "Stain noncontributory",
  "ordered-error": "Stain ordered in error",
  "incorrect-stain": "Incorrect stain",
  "processing-not-optimal": "Processing not technically optimal",
};
export const noChargeReasonEnumToLabel = (
  shortEnum: LabOrder.no_charge_reason
) => {
  return (shortEnum && noChargeReasonLabels[shortEnum]) || shortEnum;
};
